import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import RentalRenterLicenseDetailScreen from './screens/RentalRenterLicenseDetailScreen';
import RentalRenterLicenseListScreen from './screens/RentalRenterLicenseListScreen';

function RentalRenterLicenses() {
  return (
    <KT01BaseLayout isFullScreen>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<RentalRenterLicenseListScreen />} />
          <Route path=":rentalRenterLicenseId" element={<RentalRenterLicenseDetailScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default RentalRenterLicenses;
